import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Elige tu servicio',
  description: 'Explora las opciones y encuentra la que resuene contigo.'
}, {
  number: '02',
  title: 'Reserva o compra',
  description: 'Agenda tu sesión en el calendario o realiza tu compra.'
}, {
  number: '03',
  title: 'Recibe acompañamiento',
  description: 'Vive una experiencia profunda y transformadora.'
}, {
  number: '04',
  title: 'Continúa tu proceso',
  description: 'Integra los cambios y sigue evolucionando.'
}];
export function Process() {
  return <section className="py-24 relative overflow-hidden" data-id="element-246">
      {/* Soft background image */}
      <div className="absolute inset-0 z-0" data-id="element-247">
        <img src="https://cdn.magicpatterns.com/uploads/fbQ74FsC3s2dT3V3tvS8GU/2.png" alt="" className="w-full h-full object-cover object-center" aria-hidden="true" data-id="element-248" />
        <div className="absolute inset-0 bg-white/[0.78]" data-id="element-249" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-250">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-251">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-serif text-stone-900 mb-4" data-id="element-252">
            Tu camino hacia la{' '}
            <span className="text-violet-600 italic" data-id="element-253">transformación</span>
          </motion.h2>
        </div>

        <div className="relative" data-id="element-254">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-violet-100 -translate-y-1/2 z-0" data-id="element-255" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6 relative z-10" data-id="element-256">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="flex flex-col items-center text-center group" data-id="element-257">
                <div className="w-16 h-16 rounded-full bg-white border-4 border-violet-100 flex items-center justify-center mb-6 group-hover:border-violet-300 transition-colors duration-300 shadow-sm" data-id="element-258">
                  <span className="font-serif text-xl font-bold text-violet-600" data-id="element-259">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-xl font-serif font-semibold text-stone-900 mb-3" data-id="element-260">
                  {step.title}
                </h3>
                <p className="text-stone-600 font-light" data-id="element-261">{step.description}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}